// ─── agents/claude — Claude Code tool_call → ToolAction mapper ──────────────────────
//
// AGENT-SPECIFIC (per the split in toolAction.ts): Claude Code's exact tool names + their
// toolInput shapes. Other agents that name/shape these differently get their OWN file. The
// rendering is shared (components/turns/ToolCard.tsx) — this only EXTRACTS normalized data.

import type { ToolAction, ToolMapper } from './toolAction'
import { parseInput } from './toolAction'

export const claudeToolAction: ToolMapper = (turn): ToolAction | null => {
  const name = (turn.toolName || '').trim()
  if (!name) return null
  const input = parseInput(turn) ?? {}
  const s = (k: string): string => (typeof input[k] === 'string' ? (input[k] as string) : '')
  const num = (k: string): number | undefined => (input[k] != null && !Number.isNaN(Number(input[k])) ? Number(input[k]) : undefined)

  switch (name) {
    case 'Edit':
      return { kind: 'edit', file: s('file_path'), hunks: [{ old: s('old_string'), new: s('new_string') }] }
    case 'MultiEdit':
      return {
        kind: 'edit',
        file: s('file_path'),
        hunks: ((input.edits as Array<Record<string, string>>) ?? []).map(e => ({ old: e.old_string ?? '', new: e.new_string ?? '' })),
      }
    case 'NotebookEdit':
      return { kind: 'edit', file: s('notebook_path') || s('file_path'), hunks: [{ old: s('old_source'), new: s('new_source') }] }
    case 'Write':
      return { kind: 'write', file: s('file_path'), content: s('content') }
    case 'Read':
      return { kind: 'read', file: s('file_path'), offset: num('offset'), limit: num('limit') }
    case 'Bash':
      return { kind: 'bash', command: s('command'), description: s('description') }
    case 'Grep':
      return { kind: 'search', engine: 'grep', query: s('pattern'), path: s('path') }
    case 'Glob':
      return { kind: 'search', engine: 'glob', query: s('pattern'), path: s('path') }
    case 'LS':
      return { kind: 'search', engine: 'ls', query: s('path') }
    case 'WebFetch':
      return { kind: 'fetch', url: s('url') }
    case 'WebSearch':
      return { kind: 'websearch', query: s('query') }
    case 'TodoWrite':
      return {
        kind: 'todos',
        todos: ((input.todos as Array<{ content?: string; status?: string }>) ?? []).map(t => ({ content: t.content ?? '', status: t.status ?? 'pending' })),
      }
    case 'Task':
      return { kind: 'task', subagent: s('subagent_type'), description: s('description') || s('prompt') }
    default:
      return null // unknown Claude tool → let the generic mapper try
  }
}
